'use client';

import Slider, { Settings } from 'react-slick';
import { defaultSettings } from 'constant';
import Image, { StaticImageData } from 'next/image';

import { Box } from '@chakra-ui/react';

type CarouselProps = {
  banners: StaticImageData[];
  settings?: Settings;
  borderRadius?: number;
};

const Carousel = ({
  banners,
  settings = {},
  borderRadius = 0
}: CarouselProps) => {
  const carouselSettings = { ...defaultSettings, ...settings };

  return (
    <Slider {...carouselSettings} adaptiveHeight variableWidth={false}>
      {banners.map((url: StaticImageData) => (
        <Box
          as={Image}
          priority
          key={url.toString()}
          alt={`banner-${url}`}
          src={url}
          quality={100}
          sx={{
            objectFit: 'cover',
            width: '100%',
            borderRadius
          }}
        />
      ))}
    </Slider>
  );
};

export default Carousel;
